export const RESET = 'PRODUCT_LIST_RESET'
export const SET_ITEMS = 'PRODUCT_LIST_SET_ITEMS'
export const SET_ERROR = 'PRODUCT_LIST_SET_ERROR'
export const SET_SELECT_ITEMS = 'PRODUCT_LIST_SET_SELECT_ITEMS'
export const SET_VIEW = 'PRODUCT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'PRODUCT_LIST_TOGGLE_LOADING'
